import { AfterViewInit, Component, inject, Input, OnInit } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { ThemeService } from '../../common/_theme/theme.service';

@Component({
  selector: 'app-splash-screen-page',
  imports: [NgIf, TranslatePipe, NgClass],
  templateUrl: './splash-screen-page.component.html',
})
export class SplashScreenPageComponent implements OnInit, AfterViewInit {
  private themeService = inject(ThemeService);

  @Input() showSpinner: boolean = true;
  visible: boolean = false;
  imgUrl: string;
  version: string;

  async ngOnInit() {
    this.imgUrl =
      await this.themeService.getValueFromConfigurationThemeByKey('logoSpalshScreenUrl');

    // Setting application version
    const res = await firstValueFrom(this.themeService.getVersion());
    this.version = res.version;
  }

  ngAfterViewInit() {
    setTimeout(() => (this.visible = true));
  }
}
